import { render, staticRenderFns } from "./PasscodeResetPage.vue?vue&type=template&id=3a3ef5e0&scoped=true"
import script from "./PasscodeResetPage.vue?vue&type=script&lang=js"
export * from "./PasscodeResetPage.vue?vue&type=script&lang=js"
import style0 from "./PasscodeResetPage.vue?vue&type=style&index=0&id=3a3ef5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3ef5e0",
  null
  
)

export default component.exports